import { createContext } from "react";

import { IAuthStore } from "stores/AuthStore";

export interface AuthOptions
{
  authStore: IAuthStore;
  isInProgress: () => boolean;
  signInAsync: () => Promise<void>;
  signOutAsync: () => Promise<void>;
  accessDenied: React.ReactNode;
  accessDeniedUrl?: string;
  redirectToAccessDeniedUrl?: () => void;
}
export const AuthContext = createContext<AuthOptions | null>(null);
